/* eslint-disable import/prefer-default-export */
import globalApi from '@/request/globalApi/globalApi'

const END_POINT = 'api/mail-event'

export const fetchMailEventsRequest = queryParams => globalApi.get(END_POINT, { params: queryParams })
